import { render, staticRenderFns } from "./question-04.vue?vue&type=template&id=bbc7e4a0&scoped=true&lang=pug"
var script = {}
import style0 from "./question-04.vue?vue&type=style&index=0&id=bbc7e4a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc7e4a0",
  null
  
)

export default component.exports